var _title, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCloud = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      fill: "var(--color--primary-text)"
    },
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "weather-cloud-1")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.513,12.443a.252.252,0,0,1-.071-.218A4.6,4.6,0,0,0,22.5,11.5a4.489,4.489,0,0,0-3.517-4.392.251.251,0,0,1-.171-.136,7,7,0,0,0-12.988.915.251.251,0,0,1-.205.173A6.5,6.5,0,0,0,6.5,21H19a5,5,0,0,0,3.513-8.557ZM22,16a3,3,0,0,1-3,3H6.5a4.5,4.5,0,1,1,.081-9h0a1,1,0,0,0,.986-.835,5,5,0,0,1,9.647-.83,1,1,0,0,0,.9.667,2.5,2.5,0,0,1,2.232,3.365,1,1,0,0,0,.366,1.169A3,3,0,0,1,22,16Z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCloud, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/cloud.a72640d7.svg";
export { ForwardRef as ReactComponent };